import Vue from 'vue'
import App from './App.vue'
import 'ant-design-vue/dist/antd.less'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'
import { VueAxios } from "@/utils/request"
import Antd from 'ant-design-vue'
import vueClapButton from 'vue-clap-button'
import {updateTheme} from '@/utils/setting.js'
import Viser from 'viser-vue'

import '@/utils/filter' // base filter
import Jump from '@/utils/jump'
/*import '@babel/polyfill'*/
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video //引入Video播放器
import JeecgComponents from '@/components/jeecg/index'
import JDictSelectTag from './components/dict/index.js'
Vue.use(JeecgComponents);
Vue.use(JDictSelectTag);

//直播助手
import LiveControl from './components/common/LiveControl'
Vue.use(LiveControl)
//打字机
// import VueTypedJs from 'vue-typed-js'
// Vue.use(VueTypedJs)
//抽奖组件
import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas);

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import "swiper/css/swiper.css";
import 'swiper/dist/css/swiper.css'

import VueI18n from 'vue-i18n' //国际化
// localStorage.setItem('lang','zh')
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale:(function(){
    if(localStorage.getItem('lang')){
      return localStorage.getItem('lang')
    }
    return 'zh'
  }()),
  messages:{
    'en':require('./assets/lang/en'), //英文语言包
    'zh':require('./assets/lang/zh'), //中文语言包
  }
})

import '@/directive/vdown'
import '@/directive/vcopy'

import { getTenantConfig,getSysConfig,getMenu } from "@/api/sys";
import {
  ACCESS_TOKEN,
  USER_INFO,
  USER_DEPART,
  WECHAT_INFO,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_PAGE,
  TENANT_CONFIG,
  TENANT_ID,
  MENU,
  SYSTEM_INFO
} from "@/store/mutation-types"
import config from '@/defaultSettings'

import hasPermission from '@/utils/hasPermission'
import vueBus from '@/utils/vueBus';
import '@/assets/less/JAreaLinkage.less'
import VueAreaLinkage from 'vue-area-linkage'
import animated from 'animate.css'

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad)

//图像阴影
import ImageShadow from 'vue-image-shadow'
Vue.component('image-shadow', ImageShadow)

// markdown
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
Vue.use(mavonEditor);


Vue.config.productionTip = false
Vue.use(Storage, config.storageOptions)
Vue.use(Antd)
Vue.use(VueAxios, router)
Vue.use(Viser)
Vue.use(hasPermission)
Vue.use(preview)
Vue.use(vueBus);
Vue.use(VueAreaLinkage);
Vue.use(animated)
Vue.use(Jump)
Vue.use(vueClapButton);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

let isOpen = false; //是否为开源版
let cacheTime = 36000000 //缓存10小时

const updateThemeColors = (themeVars) => {
  console.log(themeVars , 'themeVars')
  if (window.less) {
    const lessConfigNode = document.createElement('script');

    console.log(window.less , 'window.less.modifyVars')
    window.less.modifyVars(themeVars).then((res) => {
      console.log('主题颜色已更新',res);
    }).catch(error => {
      console.error('Failed to update theme colors:', error);
    });
  }else{
    console.error('less is not defined');
  }
};


const start = async()=>{
  //获取配置
  let tenantConfig = Vue.ls.get(TENANT_CONFIG);
  let systemInfo= Vue.ls.get(SYSTEM_INFO)
  let configReq;
  if(isOpen){//开源版获取网站配置
    configReq = getSysConfig()
  }else{//商业版获取租户配置
    configReq = getTenantConfig()
  }
  let getConfigCallback = function(res){
    if (res.success) {
      tenantConfig = res.result
      updateTheme(tenantConfig.systemColor)
      Vue.ls.set(TENANT_CONFIG, tenantConfig, cacheTime)
      store.commit('SET_TENANT_CONFIG', tenantConfig)
      Vue.ls.set(TENANT_ID, tenantConfig.id, cacheTime)
      store.commit('SET_TENANT', tenantConfig.id)
    }
  }
  if (!tenantConfig) {
      await configReq.then(getConfigCallback)
  }else{
    configReq.then(getConfigCallback)
  }



  //请求动态菜单
  if (store.getters.menuList == null) {
      await getMenu().then(res => {
        const menuData = res.result;
        Vue.ls.set(MENU, menuData, cacheTime)
        store.commit('SET_MENU', menuData)
      })
  }else{
    getMenu().then(res => {
      const menuData = res.result;
      Vue.ls.set(MENU, menuData, cacheTime)
      store.commit('SET_MENU', menuData)
    })
  }
  //渲染页面
  new Vue({
    router,
    store,
    i18n,
    created(){

      // if(systemInfo && systemInfo.schoolName || tenantConfig.brandName){
      //   window.document.title = systemInfo ? systemInfo.schoolName : tenantConfig.brandName
      // }
      if(tenantConfig.customJS){
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.textContent = tenantConfig.customJS
        document.head.appendChild(script)
      }
      if(tenantConfig.customCss){
        let style = document.createElement('style')
        style.type = 'text/css'
        style.textContent = tenantConfig.customCss
        document.head.appendChild(style)
      }
    },
    mounted () {
      store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
      store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
      store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
      store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
      store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
      store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
      store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
      store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
      store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
      store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
      store.commit('SET_USER_INFO', Vue.ls.get(USER_INFO))
      store.commit('SET_USER_DEPART', Vue.ls.get(USER_DEPART))
      store.commit('SET_WECHAT_INFO', Vue.ls.get(WECHAT_INFO))
      store.commit('SET_MULTI_PAGE',Vue.ls.get(DEFAULT_MULTI_PAGE,config.multipage))
      store.commit('SET_TENANT_CONFIG', Vue.ls.get(TENANT_CONFIG))
    },
    render: h => h(App)
  }).$mount('#app')
}
start()